if (!customElements.get('indriya-cart-discovery')) {
  customElements.define('indriya-cart-discovery', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.ij-bag__rail');
      this.cards = [...this.querySelectorAll('[data-bag-card]')];
      this.dots = [...this.querySelectorAll('[data-bag-slide]')];
      if (!this.rail || this.cards.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('.ij-bag__dots').hidden = false;
      this.dots.forEach((button, index) => {
        button.addEventListener('click', () => this.goTo(index), options);
        button.setAttribute('aria-label', `Discover ${this.cards[index].querySelector('h4').textContent.trim()}`);
      });
      this.rail.addEventListener('scroll', () => this.updateDots(), { ...options, passive: true });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.goTo(Math.max(0, Math.min(this.cards.length - 1, this.currentIndex + (event.key === 'ArrowRight' ? 1 : -1))));
      }, options);
      this.observer = new ResizeObserver(() => this.updateDots());
      this.observer.observe(this.rail);
      this.updateDots();
    }

    goTo(index) {
      const card = this.cards[index];
      this.rail.scrollTo({
        left: card.offsetLeft - (this.rail.clientWidth - card.clientWidth) / 2,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }

    updateDots() {
      const center = this.rail.scrollLeft + this.rail.clientWidth / 2;
      this.currentIndex = this.cards.reduce((closest, card, index) => {
        const distance = Math.abs(card.offsetLeft + card.clientWidth / 2 - center);
        const previous = this.cards[closest];
        return distance < Math.abs(previous.offsetLeft + previous.clientWidth / 2 - center) ? index : closest;
      }, 0);
      this.dots.forEach((button, index) => {
        if (index === this.currentIndex) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
